import { COLORS, FONTS } from '../../constants';

const styles = theme => {
  const minMd = theme.breakpoints.up('md');
  const minSm = theme.breakpoints.up('sm');

  return {
    cardRoot: {
      borderRadius: 0,
      [minSm]: {
        borderRadius: 4,
      },
    },
    heading: {
      fontFamily: FONTS.SECONDARY,
      color: COLORS.GREEN,
      fontSize: '1.25rem',
      textAlign: 'center',
      fontWeight: 700,
      marginTop: 0,
    },
    actionsRow: {
      marginTop: 50,
    },
    formButtons: {
      marginTop: 24,
      display: 'flex',
      '& > button': {
        flex: '1',
      },
    },
    hidden: {
      display: 'none',
    },
    formGroup: {
      marginTop: 24,
    },
    modalPaper: {
      marginLeft: 0,
      marginRight: 0,
    },
    root: {
      fontFamily: FONTS.PRIMARY,
      color: COLORS.GREY_DARK,
      // paddingTop: 80,
      [minMd]: {
        paddingTop: 0,
      },
    },
    selectRoot: {
      width: '100%',
    },
    topCloseButton: {
      zIndex: 999,
      position: 'fixed',
      right: 5,
      top: 14,
      color: COLORS.WHITE,
      [minMd]: {
        top: 0,
        right: 0,
        color: COLORS.GREEN,
        position: 'absolute',
      },
    },
    toolBar: {
      zIndex: 9,
      top: 0,
      left: 0,
      width: '100%',
      backgroundColor: COLORS.GREEN,
    },
    plannedStartDate: {
      fontSize: '100px',
      width: '100%',
      color: 'red',
    },
  };
};

export default styles;
